import { useEffect } from "react";
import { SITE_URL, OG_IMAGE } from "../data/constants";

export const usePageSEO = ({ title, description, path = "/", image, type = "website", noindex = false }) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    const ogImage = image || OG_IMAGE;
    const robotsContent = noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

    document.title = title;

    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, attrValue); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    setMeta("name", "description", description);
    setMeta("name", "robots", robotsContent);
    setLink("canonical", canonical);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:locale", "fr_CH");
    setMeta("property", "og:site_name", "Body-Up Personal Training Nyon");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);
  }, [title, description, path, image, type, noindex]);
};

export const SEOHead = ({ title, description, path, image, type, noindex }) => {
  usePageSEO({ title, description, path, image, type, noindex });
  return null;
};
